





























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class MenuMain extends Vue {
  @Prop() items?: any;

  navigate(path: string) {
    if (path) {
      this.$router.push(path);
    }
  }
}
